const EVENT_CODE = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  left: "ArrowLeft",
  // 37
  up: "ArrowUp",
  // 38
  right: "ArrowRight",
  // 39
  down: "ArrowDown",
  // 40
  esc: "Escape",
  delete: "Delete",
  backspace: "Backspace",
  numpadEnter: "NumpadEnter",
  pageUp: "PageUp",
  pageDown: "PageDown",
  home: "Home",
  end: "End"
};

export { EVENT_CODE };
//# sourceMappingURL=aria.mjs.map
